<!-- Drawer.svelte -->
<script>
  import { spring } from 'svelte/motion';
  import { cubicOut } from 'svelte/easing';

  export let isOpen = false;
  export let toggleShowMenu;
  
  const DRAG_THRESHOLD = 20;

  let y = spring(100, {
    stiffness: 0.2,
    damping: 0.8,
    precision: 0.01
  });

  $: {
    y.set(isOpen ? 0 : 100, { hard: false });
  }

  let drawerElement;
  let isDragging = false;
  let startY, currentY;
  let pointerDown = false;

  function handlePointerDown(event) {
    if (!isOpen) return;
    pointerDown = true;
    isDragging = false;
    startY = event.clientY || (event.touches && event.touches[0].clientY);
    currentY = startY;
  }

  function handlePointerMove(event) {
    if (!isOpen || !pointerDown) return;
    const clientY = event.clientY || (event.touches && event.touches[0].clientY);
    if (clientY === undefined) return;

    const deltaY = clientY - startY;

    if (!isDragging && Math.abs(deltaY) > DRAG_THRESHOLD) {
      isDragging = true;
    }

    if (isDragging) {
      currentY = clientY;
      const newPosition = (deltaY / drawerElement.clientHeight) * 100;
      y.set(Math.max(0, Math.min(100, newPosition)), { hard: true });
      event.preventDefault();
    }
  }

  function handlePointerUp(event) {
    pointerDown = false;
    if (!isOpen || !isDragging) return;
    
    const deltaY = currentY - startY;
    const threshold = drawerElement.clientHeight * 0.4;  // 40% threshold

    if (deltaY > threshold) {
      closeDrawer();
    } else {
      y.set(0);
    }

    isDragging = false;
  }

  function closeDrawer() {
    y.set(110, { hard: false }).then(() => {
      isOpen = false;
      toggleShowMenu(true);
    });
  }

  function handleTransitionEnd(event) {
    if (event.target === drawerElement && $y >= 100) {
      isOpen = false;
      toggleShowMenu(true);
    }
  }

  // Reset state when drawer opens or closes
  $: {
    if (isOpen) {
      isDragging = false;
      pointerDown = false;
    }
  }
</script>

<svelte:window
  on:pointermove={handlePointerMove}
  on:pointerup={handlePointerUp}
  on:pointercancel={handlePointerUp}
/>

<div
  class="drawer"
  class:open={isOpen}
  style="transform: translateY({$y}%);"
  on:pointerdown={handlePointerDown}
  bind:this={drawerElement}
  on:transitionend={handleTransitionEnd}
>
  <div class="handle"></div>
  <span class="legal">Spel från Svenska Spel Sport & Casino AB. Åldersgräns 18 år. <br />Stödlinjen 020-81 91 00. <a href="https://spelalagom.se">Spelalagom.se</a></span>
  <button class="close-button" on:click={closeDrawer}>×</button>
  <div class="drawerContent">
    <slot></slot>
  </div>
</div>

<style>
  .drawer {
    z-index: 100;
    position: fixed;
    bottom: 43pt;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 865px;
    margin-left: auto;
    margin-right: auto;
    height: calc(100% - 98pt);
    background-color: #f0f0f0;
    border-radius: 10pt;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    opacity: 0;
    pointer-events: none;
    touch-action: none;
  }

  .drawer.open {
    opacity: 1;
    pointer-events: all;
  }

  .handle {
    width: 50px;
    height: 5px;
    background-color: #ccc;
    border-radius: 3px;
    margin: 10px auto;
    cursor: ns-resize;
  }

  .legal {
    position: absolute;
    top: 15px;
    width: calc(100vw - 52px);
        max-width: 805px;
    left: 2px;
    font-size: 8pt;
/*     border: 1pt solid red; */
  }

  .drawerContent {
    padding: 20px;
    touch-action: pan-y;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20pt;
    cursor: pointer;
    padding: 0 10pt 3pt 10pt;
    margin: 0;
  }

  .close-button:hover {
    background: rgba(255,255,255,1);
    border-radius: 20pt;
  }

  @media (max-width: 768px) {
    .drawer {
      bottom: var(--drawerBottom);
      height: calc(100% - var(--drawerHeight));
    }
    .legal {
      font-size: 7pt;
      top: 19px;
    }
  }
</style>